import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import CheckoutSection from './utils/Checkout.Section';
import CheckoutSectionContent from './utils/Checkout.SectionContent';
import { translate } from '../../Services/translation';
import useDebouncedOnChange from '../../Hooks/useDebouncedOnChange';
import {
  setOrderNote as setOrderNoteAction,
  submitAlternateOrderNumber,
  submitOrderNote,
  submitExtraReference,
} from '../../Actions/Checkout.action';
import { useTypedSelector } from '../../Hooks/useTypedSelector';
import TextArea from '../Inputs/TextArea';
import EditorString from '../EditorString/EditorString';
import Input from '../Inputs/Input';

const AdditionalOrderInfo = ({ showExtra }: { showExtra: Boolean }) => {
  const dispatch = useDispatch();
  const checkout = useTypedSelector((state) => state.checkout);
  const { customerServiceMessage, customerMessage, alternateOrderNumber } =
    checkout.payload;
  const [comments, setOrderNote] = useDebouncedOnChange(
    customerMessage,
    () => dispatch(submitOrderNote(comments))
  );

  const [alternateReference, setAlternateReference] = useDebouncedOnChange(
    alternateOrderNumber,
    () =>
      showExtra && dispatch(submitAlternateOrderNumber(alternateReference))
  );

  return (
    <div className="mb-2">
      {showExtra && (
        <>
          <Input
            inputSize="large"
            className="mb-4 mt-4"
            maxLength={30}
            placeholder={translate('checkout.alternate-order-number')}
            value={alternateReference}
            onChange={(e) => setAlternateReference(e.target.value)}
          />
        </>
      )}

      <p className="font-bold">{translate('checkout.order.message')}</p>
      {customerServiceMessage && (
        <div className="mb-4 text-lg">
          <EditorString value={customerServiceMessage.value} />
        </div>
      )}

      <TextArea
        inputSize="xlarge"
        className="mb-4"
        id="additional-info__input"
        value={comments}
        placeholder={translate('checkout.ordernote.placeholder')}
        onChange={(e) => setOrderNote(e.target.value)}
      />
    </div>
  );
};

export default AdditionalOrderInfo;
